import React from "react";
import moment from "moment";

const ChartsTable = ({ data, dataCount, parameters, onClick, loading }) => {
  if (!loading && (dataCount === 0 || data[0].REAL_DATE === null))
    return (
      <div className="col">
        <p className="text-center">No Data</p>
      </div>
    );
  return (
    <table className="table table-striped table-sm table-responsive mt-3">
      <thead>
        <tr>
          <th className="align-middle" rowSpan="4">
            Date
          </th>
          <th className="align-middle" rowSpan="4">
            Hour
          </th>
          {parameters.map((parameter, i) => (
            <th key={parameter.CODE + i} className="text-center text-nowrap">
              <button
                className="btn btn-link"
                onClick={() => onClick(parameter)}
              >
                {parameter.HEADING1}
              </button>
            </th>
          ))}
        </tr>
        <tr>
          {parameters.map((parameter, i) => (
            <th key={parameter.CODE + i} className="text-center text-nowrap">
              <button
                className="btn btn-link"
                onClick={() => onClick(parameter)}
              >
                {parameter.HEADING2}
              </button>
            </th>
          ))}
        </tr>
        <tr>
          {parameters.map((parameter, i) => (
            <th key={parameter.CODE + i} className="text-center text-nowrap">
              <button
                className="btn btn-link"
                onClick={() => onClick(parameter)}
              >
                {parameter.HEADING3}
              </button>
            </th>
          ))}
        </tr>
        <tr>
          {parameters.map((parameter, i) => (
            <th key={parameter.LABEL + i} className="text-center text-nowrap">
              <button
                className="btn btn-link"
                onClick={() => onClick(parameter)}
              >
                {parameter.LONG_SITE}
              </button>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((record) => (
          <tr key={record.REAL_DATE + record.REAL_HOUR}>
            <td className="text-nowrap">
              {moment(record.REAL_DATE).format("DD-MMM-YY")}
            </td>
            <td className="text-nowrap">{record.REAL_HOUR}</td>
            {parameters.map((parameter, i) => (
              <td key={parameter.CODE + i} className="text-center">
                {record[`${parameter.CODE}-${parameter.SITE}`]
                  ? record[`${parameter.CODE}-${parameter.SITE}`].toFixed(
                      parameter.DISPLAY_PRECISION
                    )
                  : record[`${parameter.CODE}-${parameter.SITE}`]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ChartsTable;
